import { useState } from "react";
import ProfileLayout from "./layout";
import { Container, Dropdown } from "react-bootstrap";
import BankAccountCreate from "./bank-account-create";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { BankAccountProvider, useBankAccount } from "contexts/v1/pages/BankAccountContext";
import Swal from "sweetalert2";

const BankAccounts = () => {
    const { bankAccounts, handleSearch, Pagination, refetch, removeBankAccount } = useBankAccount();
    const [search, setSearch] = useState("");

    const { handleError, handleSuccess, showCanvasHandler } = useCanvasHandler();

    const handleCreate = (e) => {
        e.stopPropagation();
        showCanvasHandler('Create Bank Account',
            <BankAccountProvider>
                <BankAccountCreate onSuccess={(response) => {
                    handleSuccess(true, response.message);
                    refetch();
                }} onError={(response) => {
                    handleError(true, response.message);
                }} />
            </BankAccountProvider>
        );
    };

    const handleUpdate = (e, account) => {
        e.preventDefault();
        showCanvasHandler('Update Bank Account',
            <BankAccountProvider>
                <BankAccountCreate
                    initialData={account}
                    onSuccess={(response) => {
                        handleSuccess(true, response.message);
                        refetch();
                    }} onError={(response) => {
                        handleError(true, response.message);
                    }} />
            </BankAccountProvider>
        );
    };

    const handleDelete = (id) => {
        // add sweetalert confirmation delete
        const confirm = Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            customClass: {
                confirmButton: 'btn btn-danger me-2',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false,
        }).then((result) => {
            if (result.isConfirmed) {
                removeBankAccount(id).then((response) => {
                    handleSuccess(true, response.message);
                    refetch();
                }).catch((error) => {
                    handleError(true, error.message);
                });
            }
        });
    };

    return (
        <ProfileLayout>
            <Container className="mt-4">
                <h2>Bank Accounts</h2>
                <div className="table-container rounded-0 shadow-none">
                    {/* Search and Create */}
                    <div className="d-flex justify-content-between mb-3">
                        <input
                            type="text"
                            className="form-control w-50"
                            placeholder="Search bank accounts..."
                            disabled={bankAccounts.loading}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => {
                                handleSearch(e);
                            }}
                            value={search}
                        />
                        <button className="btn btn-primary" onClick={handleCreate}>
                            Create
                        </button>
                    </div>

                    {/* Table */}
                    <div className="table mb-3">
                        <table className="table table-hover table-vcenter position-relative">
                            {bankAccounts.loading &&
                                (
                                    <div class="spinner-overlay table-spinner-overlay active">
                                        <div class="spinner-border table-spinner-border text-primary" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )
                            }
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Bank Name</th>
                                    <th>Bank Account</th>
                                    <th>Bank Number</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            {bankAccounts.data && bankAccounts.data.length > 0 ? (
                                <tbody>
                                    {bankAccounts.data.map((account, index) => (
                                        <tr key={account.id}>
                                            <td>{index + 1}</td>
                                            <td>{account.bank_name}</td>
                                            <td>{account.bank_account}</td>
                                            <td>{account.bank_number}</td>
                                            <td className="text-end">
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="default" id={`dropdown-${account.id}`}>
                                                        Actions
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item
                                                            href="#"
                                                            onClick={(e) => handleUpdate(e, account)}
                                                        >
                                                            Edit
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDelete(account.id);
                                                            }}
                                                        >
                                                            Remove
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No bank accounts available
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>

                    {/* Pagination Placeholder */}
                    {Pagination}
                </div>
            </Container>
        </ProfileLayout>
    );
};

// Styling untuk panel konten
const panelStyle = {
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
    height: "300px", // Sesuaikan tinggi panel
    overflowY: "auto",
};

export default BankAccounts;